import {getCookie} from '../../utils/cookies'
import cookieConfig from './cookieConfig'

export const getFirstVisit = () => getCookie(cookieConfig.name)
